import { PlatformUserEvents } from "~/modules/analytics/events/platforms";
import { track } from "../analytics/track";
import { LeagueTableGroupTypes } from "~/modules/league_tables/types";

// // // //

/**
 * trackChangeNetFlowsIncludeStablecoins
 * Tracks the event when a user toggles the "include stablecoins" button in the Platform Net Flows card
 */
export function trackChangeNetFlowsIncludeStablecoins(props: {
    includeStablecoins: boolean;
}) {
    track(PlatformUserEvents.ChangeNetFlowsIncludeStablecoins, props);
}

/**
 * trackChangeNetFlowsChangeTimeframe
 * Tracks the event when a user changes the timeframe in the Platform Net Flows card
 */
export function trackChangeNetFlowsChangeTimeframe(props: {
    timeframe: string;
}) {
    track(PlatformUserEvents.ChangeNetFlowsChangeTimeframe, props);
}

/**
 * trackChangePieChartIncludeStablecoins
 * Tracks the event when a user toggles the "include stablecoins" button in the Platform Pie Chart
 */
export function trackChangePieChartIncludeStablecoins(props: {
    includeStablecoins: boolean;
}) {
    track(PlatformUserEvents.ChangePieChartIncludeStablecoins, props);
}

/**
 * trackChangePieChartGroupBy
 * Tracks the event when a user changes the group by in the Platform Pie Chart
 */
export function trackChangePieChartGroupBy(props: {
    platformSlug: string;
    prevValue: LeagueTableGroupTypes;
    nextValue: LeagueTableGroupTypes;
}) {
    track(PlatformUserEvents.IndividualPieChartChangeGroupBy, props);
}
